import type { profile as en } from '@/i18n/locales/en/profile';
import type { Translation } from '@/i18n/types';

export const profile: Translation<typeof en> = {
  title: 'Profiel',
  lead: 'Je naam, taal en privacy-instellingen.',
  pendingBadge: '{{count}} openstaand toestemmingsverzoek',
  nav: {
    label: 'Profielmenu',
    profile: 'Profiel',
    consents: 'Toestemmingen',
    preferences: 'Voorkeuren',
    subscription: 'Abonnement',
  },
  preferredLanguage: 'Voorkeurstaal',
  preferredLanguageOptional: 'Voorkeurstaal (optioneel)',
  preferredLanguageUnset: 'Niet ingesteld',
  timezoneUnset: 'Standaard van de omgeving',
  saved: 'Opgeslagen.',
  save: 'Opslaan',
  privateFieldsHint:
    'Deze vier zijn privé — alleen jij kunt ze zien of wijzigen, wie ook de rest van je gegevens mag zien.',
  details: {
    title: 'Gegevens',
    rolesTitle: 'Rollen',
  },
  regionAndTimezone: {
    title: 'Regio & tijdzone',
  },
  fields: {
    name: 'Naam',
    email: 'E-mail',
    nickname: 'Bijnaam',
    region: 'Regio',
    regionUnset: 'Niet ingesteld',
    regionHint: 'Het land waarvoor je statistieken/rapportages worden gelokaliseerd.',
    timezone: 'Tijdzone voor statistieken',
    timezoneHint: 'De kalender waarop je statistiekdagen worden afgesloten.',
    gender: 'Geslacht',
    birthdate: 'Geboortedatum',
    height: 'Lengte (cm)',
    weight: 'Gewicht (kg)',
  },
};
